export default "__VITE_ASSET__LTNwBPL5__"